export default ['individual_micro_loan', 'group_micro_loan'];
